import {createSlice, PayloadAction} from "@reduxjs/toolkit";

export interface AccessibilityState {
    isDyslexiaOn: boolean
    isAmblyopiaOn: boolean
    isUnderlineOn: boolean
    fontSizeLevel: number
    lineSpacingLevel: number
    wordSpacingLevel: number
}

const initialState: AccessibilityState = {
    isDyslexiaOn: false,
    isAmblyopiaOn: false,
    isUnderlineOn: false,
    fontSizeLevel: 1,
    lineSpacingLevel: 1,
    wordSpacingLevel: 1,
};

export const accessibilitySlice = createSlice({
    name: 'accessibility',
    initialState,
    reducers: {
        toggleDyslexia: (
            state
        ) => {
            return {...state, isDyslexiaOn: !state.isDyslexiaOn}
        },
        toggleAmblyopia: (
            state
        ) => {
            return {...state, isAmblyopiaOn: !state.isAmblyopiaOn}
        },
        toggleUnderline: (
            state
        ) => {
            return {...state, isUnderlineOn: !state.isUnderlineOn}
        },
        setFontSizeLevel: (
            state, action
        ) => {
            return {...state, fontSizeLevel: action.payload}
        },
        setLineSpacingLevel: (
            state, action
        ) => {
            return {...state, lineSpacingLevel: action.payload}
        },
        setWordSpacingLevel: (
            state, action
        ) => {
            return {...state, wordSpacingLevel: action.payload}
        },
    },
});

export const { toggleDyslexia, toggleAmblyopia, toggleUnderline, setFontSizeLevel, setLineSpacingLevel, setWordSpacingLevel } =
    accessibilitySlice.actions;

export default accessibilitySlice.reducer;
